<template>
    <div class="projects-filter">
        <h3>
            <span v-if="lang == ''">Выберите вид строительства:</span>
            <span v-if="lang == 'kz/'">Құрылыс түрін таңдаңыз:</span>
            <span v-if="lang == 'en/'">Choose the type of construction:</span>
        </h3>
        <div class="dropwdown-filter-select">
            <div class="curent-value" :class="{'open' : openDropCategory}">
                <a href="#" :class="{active : currentFilter == 'all'}" @click.prevent="openDropCategory = !openDropCategory"><span v-if="lang == ''">Все виды строительства</span><span v-if="lang == 'kz/'">Құрылыстың барлық түрлері</span><span v-if="lang == 'en/'">All types of construction</span></a>
                <a href="#" :class="{active : currentFilter == item.filter_type.slug}" v-for="(item, index) in pageSetup.our_projects_filter_setup" :key="index" @click.prevent="openDropCategory = !openDropCategory">{{item.filter_name}}</a>
                <div class="drop-icon"><svgIcon name="arrow_drop" class="icon-svg"/></div>
            </div>
            <!-- filterComplexesInDrop('all'), setActiveParam('city', 'all'),  -->
            <div class="dropdown-menu-category" :class="{'open' : openDropCategory}">
                <div class="item-R">
                    <input type="radio" :id="'category_all'" :value="true" v-model="resetCategory">
                    <label :for="'category_all'" @click="setActiveParam('all'), openDropCategory = false"><span v-if="lang == ''">Все виды</span><span v-if="lang == 'kz/'">Барлық түрлері</span><span v-if="lang == 'en/'">All types</span></label>
                </div>
                <div class="item-R" v-for="(item, index) in pageSetup.our_projects_filter_setup" :key="index" v-if="currentProjectPage == 'built' || currentProjectPage == 'construction' && item.init_construction == 'true'">
                    <input type="radio" :id="'category_' + item.filter_type.slug" :value="item.filter_type.slug" v-model="categoryRadioChecked">
                    <label :for="'category_' + item.filter_type.slug" @click="setActiveParam(item.filter_type.slug, item.filter_type.term_id), openDropCategory = false">{{item.filter_name}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-filter',
        props: ['currentProjectPage'],
        components: {
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                lang: window.GlobalLang,
                openDropCategory: false,
                resetCategory: true,
                categoryRadioChecked: [],
                currentFilter: 'all',
            }
        },
         computed: mapGetters({
            pageSetup: 'loadProjectsPage',
        }),
        methods: {
            setActiveParam(data, type_id) {
                // console.log(data, type_id, 'test INDEX');
                // const urlDef = this.currentProjectPage + '?project_type=' + payload.param
                const urlDef = this.currentProjectPage + '/?per_page=9';
                const urlFilter = this.currentProjectPage + '?project_type=' + type_id + '&per_page=9';
                if (data != 'all') {
                    this.resetCategory = false;
                    this.currentFilter = data;
                    this.$store.commit('projectFilterDataSet', {slug: data, id: type_id});
                    this.getFilteredItems(urlFilter);
                    // this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                    // console.log(param, data)
                } else {
                    this.categoryRadioChecked = [];
                    this.resetCategory = true;
                    this.currentFilter = 'all';
                    this.$store.commit('projectFilterDataSet', {slug: 'all', id: null});
                    this.getFilteredItems(urlDef);
                    // this.$store.commit('filterDynamicParamsUpdate', { 'param': param, 'data': data });
                    // this.$store.commit('FilterDataUpdate', {param: 'reset', type: 'cityCodes', data: []})
                }
            },
            getFilteredItems(url) {
                // console.log(param, page, 'filter test');
                this.$store.dispatch('getProjectItemsByParam', {url : url, type: 'filter'});
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/projects-filter.scss';
    @import '@/styles/components/projects/respond/projects-filter-respond.scss';
    // @import '@/styles/respond/projects/projects-filter-respond.scss';
</style>